import Vue from 'vue'
import Router from 'vue-router'
import Inicio from '@/components/Inicio'
import Emirates from '@/components/Emirates'
import Turkish from '@/components/Turkish'




Vue.use(Router);

const router = new Router({
    routes: [

   
    
        {
            path: '/',
            name: 'Index',
            component: Inicio,
        },
      
        {
            path: '/Emirates',
            name: 'Emirates',
            component: Emirates,
        },
        {
            path: '/Turkish',
            name: 'Turkish',
            component: Turkish,
        }
    ]
});
router.beforeEach((to, _from, next) => {

  
    
    return next();


});
export default router;